var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystoresm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3023.7 800",
    style: {
      enableBackground: "new 0 0 3023.7 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st4{opacity:0.2;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\n\t.st5{opacity:0.12;fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\n\t.st6{opacity:0.25;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2849.9-4.9H177.2C87.9-4.9,15.6,67.4,15.6,156.7v476.9c0,89.2,72.3,161.5,161.6,161.5H2850c89.2,0,161.6-72.3,161.6-161.6 V156.7C3011.5,67.4,2939.2-4.9,2849.9-4.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4934.4707,
    y1: 1545.2178,
    x2: 4909.832,
    y2: 1532.5056,
    gradientTransform: "matrix(11.64 0 0 -22.55 -57046.8398 35051.5508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007000001,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.1,186.7c-4.9,5.3-7.8,13.5-7.8,24.1V589c0,10.6,2.8,18.8,8,23.9l1.3,1.1l211.9-211.9v-4.8l-212-211.7 L196.1,186.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 4838.9419,
    y1: 1561.8967,
    x2: 4793.687,
    y2: 1561.8967,
    gradientTransform: "matrix(9.145 0 0 -7.7 -43655.7461 12426.5537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.1,473.1l-70.7-70.7v-4.9l70.7-70.7l1.5,0.9l83.6,47.5c23.9,13.5,23.9,35.7,0,49.4l-83.6,47.5 C481.6,472.2,480.1,473.1,480.1,473.1L480.1,473.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 5034.2212,
    y1: 1546.1257,
    x2: 5008.2886,
    y2: 1512.5195,
    gradientTransform: "matrix(15.02 0 0 -11.578 -75171.6172 18340.2539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M481.6,472.2L409.4,400L196.1,613.2c7.8,8.4,20.9,9.3,35.5,1.1L481.6,472.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 5014.2261,
    y1: 1577.7781,
    x2: 5025.8057,
    y2: 1562.7778,
    gradientTransform: "matrix(15.02 0 0 -11.572 -75171.6172 18319.0566)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M481.6,327.8l-249.9-142c-14.6-8.4-27.8-7.2-35.5,1.1l213.2,213L481.6,327.8L481.6,327.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M480.1,470.7l-248.2,141c-13.9,8-26.2,7.4-34.2,0.2l-1.3,1.3l1.3,1.1c8,7.2,20.3,7.8,34.2-0.2l249.9-142 L480.1,470.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M565.2,422.2l-85.3,48.5l1.5,1.5l83.6-47.5c12-6.8,17.9-15.8,17.9-24.7C582.1,408.1,576,415.9,565.2,422.2 L565.2,422.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M231.7,188.3l333.5,189.5c10.8,6.1,16.9,14.1,17.9,22.2c0-8.9-5.9-17.9-17.9-24.7L231.7,185.8 c-23.9-13.7-43.3-2.3-43.3,25.1v2.5C188.3,186,207.7,174.8,231.7,188.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M982,362.1c0-93.2,78.3-169.1,171.5-169.1c51.5,0,88.2,20.2,115.9,46.6l-32.6,32.6c-19.8-18.6-46.6-33-83.3-33 c-68.1,0-121.3,54.8-121.3,122.9S1085.4,485,1153.4,485c44.1,0,69.2-17.7,85.3-33.9c13.2-13.2,21.8-32.1,25.2-58.1h-110.4v-46.1 H1309c1.6,8.2,2.5,18.1,2.5,28.8c0,34.6-9.5,77.5-40,108.1c-29.7,30.9-67.6,47.4-118,47.4C1060.2,531.3,981.9,455.4,982,362.1 L982,362.1L982,362.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1437.1,313.4c-60.2,0-109.3,45.8-109.3,108.8c0,62.7,49.1,108.8,109.3,108.8s109.3-46.2,109.3-108.9 C1546.4,359.2,1497.3,313.4,1437.1,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1437.1,488.3c-33,0-61.4-27.2-61.4-66c0-39.2,28.4-66,61.4-66s61.4,26.8,61.4,66 C1498.6,461.1,1470.1,488.3,1437.1,488.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1675.6,313.4c-60.2,0-109.3,45.8-109.3,108.8c0,62.7,49.1,108.8,109.3,108.8s109.3-46.2,109.3-108.9 C1784.8,359.2,1735.8,313.4,1675.6,313.4L1675.6,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1675.6,488.3c-33,0-61.4-27.2-61.4-66c0-39.2,28.4-66,61.4-66s61.4,26.8,61.4,66 C1737,461.1,1708.5,488.3,1675.6,488.3L1675.6,488.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1968.2,320.1v17.7h-1.6c-10.7-12.8-31.3-24.4-57.3-24.4c-54.4,0-104.4,47.9-104.4,109.3 c0,61,49.9,108.5,104.4,108.5c26,0,46.6-11.5,57.3-24.7h1.6v15.6c0,41.6-22.3,63.9-58.1,63.9c-29.3,0-47.4-21.1-54.9-38.7 l-41.7,17.3c11.9,28.8,43.7,64.3,96.5,64.3c56,0,103.5-33,103.5-113.4V320L1968.2,320.1L1968.2,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1913.4,488.3c-33,0-60.7-27.7-60.7-65.6c0-38.3,27.7-66.4,60.7-66.4c32.6,0,58.1,28,58.1,66.4 C1971.5,460.7,1946,488.3,1913.4,488.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2046.5,
    y: 204.6,
    className: "st7",
    width: 47.9,
    height: 320
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M2225.6,488.3c-24.3,0-41.7-11.2-52.7-33l145.6-60.3l-5-12.4c-9-24.3-36.7-69.3-93.2-69.3 c-56.1,0-102.7,44.1-102.7,108.9c0,61,46.2,108.8,108.1,108.8c49.9,0,78.8-30.5,90.7-48.3l-37.1-24.7 C2266.8,476.4,2249.9,488.4,2225.6,488.3L2225.6,488.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2221.8,355.5c19,0,35,9.5,40.4,23.1l-97.4,40.4C2163.7,377,2197.5,355.5,2221.8,355.5L2221.8,355.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoresm);
export default __webpack_public_path__ + "static/media/playstoresm.4a24fc3eb8832d73c1532a80e8f084a2.svg";
export { ForwardRef as ReactComponent };